<sh-dropdown
    #dropdown
    [label]="label()"
    [disabled]="disabled() || isDisabled()"
    [attr.mandatory]="mandatory() ? true : null"
    [error]="error()"
    display="label"
    editable
    (input)="handleSearchInput($event)"
    (active-changed)="handleActiveChanged($event)"
>
    <!-- Show selected user as the active item only while not editing -->
    @if (selectedUser && !isSearching()) {
        <sh-menu-item
            [attr.data-testid]="optionTestId() ? optionTestId() + '-' + selectedUser.gid : null"
            [label]="getUserDisplayName(selectedUser)"
            [value]="selectedUser.gid"
            [active]="true"
            (click)="handleClear()"
        ></sh-menu-item>
    }

    <!-- Show search results (filter out the already-selected user while idle) -->
    @if (searchResults().length > 0) {
        @for (user of searchResults(); track user.gid) {
            @if (isSearching() || !isUserActive(user.gid)) {
                <sh-menu-item
                    [attr.data-testid]="optionTestId() ? optionTestId() + '-' + user.gid : null"
                    [label]="getUserDisplayName(user)"
                    [value]="user.gid"
                    (click)="handleUserSelect(user)"
                ></sh-menu-item>
            }
        }
    }

    <!-- Show no results message -->
    @if (!isLoading() && searchResults().length === 0 && searchTerm()) {
        <sh-menu-item label="No users found" disabled="true"></sh-menu-item>
    }
    @if (!isLoading() && searchResults().length === 0 && !searchTerm() && !selectedUser) {
        <sh-menu-item label="No users found" disabled="true"></sh-menu-item>
    }
</sh-dropdown>
